import React from 'react';
import { ClipboardCheckIcon, BookOpenIcon, TrophyIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FeaturesSection() {
  return <section id="how-it-works" className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-135">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-136">
        <div className="text-center mb-16" data-id="element-137">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-138">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-139">
            Three simple steps to digital confidence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-140">
          {/* Step 1: Assess */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200 text-center relative" data-id="element-141">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#631bb7] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-142">
              1
            </div>
            <div className="w-16 h-16 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-[#631bb7] border-opacity-10" data-id="element-143">
              <ClipboardCheckIcon className="w-8 h-8 text-[#631bb7]" data-id="element-144" />
            </div>
            <h3 className="text-2xl font-bold text-[#111111] mb-4" data-id="element-145">Assess</h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-146">
              Answer a few questions about your devices. Get a personalized plan
              in 3 minutes.
            </p>
          </div>

          {/* Step 2: Guide */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200 text-center relative" data-id="element-147">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#631bb7] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-148">
              2
            </div>
            <div className="w-16 h-16 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-[#631bb7] border-opacity-10" data-id="element-149">
              <BookOpenIcon className="w-8 h-8 text-[#631bb7]" data-id="element-150" />
            </div>
            <h3 className="text-2xl font-bold text-[#111111] mb-4" data-id="element-151">Guide</h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-152">
              Follow bite-sized, visual lessons that show you exactly what to
              do. No jargon.
            </p>
          </div>

          {/* Step 3: Empower */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200 text-center relative" data-id="element-153">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#631bb7] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-154">
              3
            </div>
            <div className="w-16 h-16 bg-[#631bb7] bg-opacity-5 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-[#631bb7] border-opacity-10" data-id="element-155">
              <TrophyIcon className="w-8 h-8 text-[#631bb7]" data-id="element-156" />
            </div>
            <h3 className="text-2xl font-bold text-[#111111] mb-4" data-id="element-157">Empower</h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-158">
              Track your family's Security Score and celebrate as everyone
              becomes safer and savvier.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-159">
          <Link to="/intro-assessment" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-160">
            Get Started
          </Link>
        </div>
      </div>
    </section>;
}